


import NavBar from './NavBar';
import SearchBar from '../modules/xxxSearchBar';
import CardLocation from '../modules/CardLocation';
import CardAccountInfo from '../modules/CardAccountInfo';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Container from 'react-bootstrap/Container';

import ListWithHeader from '../modules/CardListWithHeader';
import { INTRFUser } from '../../hooks/Interfaces';

interface HeaderProps {
    /*itemid: string;*/
    user: INTRFUser;
    carteditems: number;
    appupdatefunc: () => void;
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}



function Header({user, carteditems, appupdatefunc, updatecsrf, updatesession}: HeaderProps){
    return (
        <> 
            <Container fluid className="block-header-content">
            
                <Row className='brand-primary-color pb-1'>
                    <Col md={{ span: 2}}>
                        <a href="/home"><img src="/ssl-logo-dark.png" className="App-logo" alt="logo" /></a>
                    </Col>
                    <Col md={{ span: 3}} className='align-self-end'>
                        <CardLocation></CardLocation>
                    </Col>
                    
                    <Col md={{ span: 3, offset: 4 }} className='align-self-end'>
                        <CardAccountInfo user={user} carteditems={carteditems} updatefunc={appupdatefunc} updatecsrf={updatecsrf} updatesession={updatesession}></CardAccountInfo>
                    </Col>
                </Row>
                <NavBar></NavBar>
            </Container>


        </>
    )
}

export default Header;